<template>
  <div>
    <page-header :title="$store.state.AppActiveUser.userRole === 'fc-operations-supervisor' ? $t('Inbound Orders') : $t('Return Orders')">
      <shipblu-button v-if="$store.state.AppActiveUser.userRole !== 'fc-operations-supervisor'" :iconStyle="{LeftIconName: 'add', LeftIconLibrary: 'material', iconPosition: 'left'}" @click="openProductModal('New Product')"/>
    </page-header>
    
    <orders-table type="inbound" :orderModal="orderModal" :confirmReturn="confirmReturn" @orderModal="orderModal = $event"/>
  </div>
</template>

<script>
import OrdersTable from './components/OrdersTable.vue'

export default {
  data () {
    return {
      orderModal: false,
      confirmReturn: true,
      order: {
        flags: [],
        customer: {
          address: {}
        }
      }
    }
  },
  methods: {
    openProductModal () {
      this.orderModal = true
    }
  },
  components: {
    OrdersTable
  }
}
</script>